// extracted by mini-css-extract-plugin
module.exports = {"footerLogos":"footerLogos_footerLogos__19tqn"};